"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PutBucketAclOutput = {
    type: "structure",
    required: [],
    members: {}
};
//# sourceMappingURL=PutBucketAclOutput.js.map